<template>
  <div>
    <img :src="imgUrl" class="app_banner_css">
  </div>
</template>

<script>
export default {
  name: 'FraudBar',
  data () {
    return {
      imgUrl: require('../../../assets/banner/fraud_bar.png')
    }
  },
  mounted() {
    let dark = this.$route.query.dark; // John
    let html = document.documentElement
    if (dark=='true') {
      html.classList.add('dark')
    } else {
      html.classList.remove('dark')
    }
  },
}
</script>
<style>
body {
  font-size: 0.0rem !important;
}
</style>




// WEBPACK FOOTER //
// src/view/pomelo/app/FraudBar.vue